import { h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { MatchHeaderStoreState } from '../../../../../services/interfaces/match-header';
import { MatchRedCards } from '../match-cards/match-cards';
import { MatchMissedPenalties } from '../match-missed-penalties/match-missed-penalties';
import { MatchScorers } from '../match-scorers/match-scorers';

type Props = {
  state: ObservableMap<MatchHeaderStoreState>['state'];
};

const MatchEvents = ({ state }: Props) => {
  const match = state.matchData;
  if (!match) return null;

  return (
    <div class="flex flex-col items-center gap-xs" part="match-events">
      <MatchScorers state={state} />
      <MatchRedCards state={state} />
      <MatchMissedPenalties state={state} />
    </div>
  );
};

export { MatchEvents };
